import React from 'react'
import { Breadcrumb } from 'antd';
import { connect } from "react-redux";
import actionWays from '../../../redux/actions.js';
import Top from '../Top'
import Footer from '../Footer.js'
import './requestProblem.scss'
class RequestProblem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabData: [],
            loading: false,
            rawHTML: '',
            rightTitle: '',
            downLoadList: [],
        }
    }
    componentDidMount() {
        this.setState({
            loading: true,
        })
    }
    render() {
        const { loading } = this.state;
        return (
            <div id={'requestProblem'} style={{ background: '#fff' }}>
                <Top />
                {loading ? <div>
                    <div className='requestProblem_top'></div>
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6">
                        <div style={{ paddingLeft: '7px', margin: '1em 0' }}>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>首页</Breadcrumb.Item>
                                <Breadcrumb.Item>常见问题</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className='requestProblem_box'>
                            <div className='rpBox_top'>
                                <p className='rpBox_top_title'>公共租赁住房常见问题</p>
                                <p className='rpBox_top_content'>
                                    <span>1、问:退休返聘人员、实习人员、港澳台及外籍人士和劳务派遣员能否租借公租房?</span>
                                    <br />
                                    答:退休返聘人员、实习人员均为无正规劳动合同人员(返聘合同、实习合同等不受《劳动合同法》保护，不是正规劳动合同，只能视为一般民事合同)，不符合公租房准入条件港澳台及外籍人士符合持有居住证、缴纳社保等公租房准入条件的，可在本区申请公租房;劳务派遣员工有正规劳动合同的可在本区申请公租房。
                                    <br />
                                    <span>2、问:租赁期限是多少?</span>
                                    <br />
                                    答:租赁合同期限一般不低于2年合同到期后承租人仍需租赁的，区公租房运营公司应重新对其准入资格进行审查，符合条件的可以续租，总租赁期限不超过6年。
                                    <br />
                                    <span>3、问:如果在合同期内想退租怎么办?</span>
                                    <br />
                                    答:在租赁期限内，承租人可以解除承租行为，但应提前2个月书面通知区公租房运营公司及本人所在单位承租双方互不承担责任。
                                    <br />
                                    <span>4、问:如想续租怎么办?</span>
                                    <br />
                                    答:租赁期限届满承租人仍需租赁的，承租人应当在租赁期满2个月前向区公租房运营公司提出申请区公租房运营公司应当对申请人是否符合条件进行审核经审核符合条件的，准许续租。未按规定提出续租申请的承租人，租赁期满应当腾退公共租赁住房拒不腾退的，区公租房运营公司可以向人民法院提起诉讼，要求承租人腾退公共租赁住房并追究其违约责任。
                                    <br />
                                    <span>5、问:承租人申请续租，申请家庭(单身申请人)因购买期房不再符合准入条件、未通过准入资格审核,所购期房尚未交付，且该申请家庭(单身申请人)在本市不拥有其他产权住房或承租公有住房怎么办?</span>
                                    <br />
                                    答:申请人可向区公租房运营公司提出延长过渡性居住期申请。备齐预告登记证明预售合同、延长过渡性居住期联系单及承诺书等相关书面材料，过渡性居住期可延长至预售合同约定的房屋交付日期之后3个月。
                                    <br />
                                    <span>6、问:奉贤区公租房可以买卖么?</span>
                                    <br />
                                    答:我区公租房不能买卖。
                                    <br />
                                    <span>7、问:奉贤区公租房累计承租或居住满6年后，还能再续租吗?</span>
                                    <br />
                                    答:公租房累计承租或居住满6年后，不再受理续租准入资格申请。同时符合以下条件的，可申请按市场化租金在公租房内过渡居住1到2年(第2年租金水平进一步提高):
                                    <br />
                                    ①申请人(本人、配偶及未婚子女)在本市不拥有产权住房(期房除外)及承租公有住房，且提出申请之日前1年内未发生过产权住房出售、赠与行为及公有住房承租权转让行为;
                                    <br />
                                    ②享受公租房保障期间遵守租赁合同及公租房管理各项规定，信用记录良好。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3"></div>
                    <Footer />
                </div> : ''}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(RequestProblem)
